import{
  Avatar,
  Flex,
  Icon,
  MenuGroup,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Box,
  MenuItemOption,
  Badge,
  Text,
  HStack,
  VStack,
  Tooltip,
  IconButton,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import React, { useCallback, useContext, useEffect, useState, useRef } from "react";
import Cookies from "js-cookie";
import { MdNotificationsNone, MdInfoOutline } from "react-icons/md";
import { IoMenuOutline } from "react-icons/io5";
import { FiBell, FiInfo, FiUser, FiLogOut, FiSettings } from "react-icons/fi";
import AuthContext from "../../contexts/Auth";
import urlToId from "../../helpers/UrlToId";
// keyframes CSS'te tanımlandı

export default function HeaderLinks({ secondary, onOpen }) {
  const bgColor = "var(--bg-elevated)";
  const borderColor = "var(--border-default)";
  const hoverBg = "var(--bg-subtle)";
  const textColor = "var(--text-default)";
  const iconColor = "var(--text-muted)";
  const notificationTextColor = "var(--text-muted)";
  const hoverBorderColor = "#0ea5e9";
  const menuGroupColor = "var(--text-muted)";
  const iconAttrs = {'paddingTop': '6px', 'boxSize': '32px'}
  const navigate = useNavigate();
  const handleAccount = () => { navigate("/account/"); };
  const handleLogOut = () => {
    localStorage.removeItem("ticketData", null);
    localStorage.removeItem("user", null);
    Cookies.remove("token");
    navigate("/giris/");
  };
  const auth = useContext(AuthContext);
  const [notifiedNumbers, setNotifiedNumbers] = useState([]);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  const lastLenRef = useRef(0);
  const showBadgeSetting = (() => { try { return localStorage.getItem('settings.notifications.showBadge') !== 'false'; } catch (_) { return true; } })();
  const soundEnabledSetting = (() => { try { return localStorage.getItem('settings.notifications.sound') === 'true'; } catch (_) { return false; } })();
  const isQuiet = () => {
    try {
      const enabled = localStorage.getItem('settings.notifications.quietHours.enabled') === 'true';
      if (!enabled) return false;
      const start = localStorage.getItem('settings.notifications.quietHours.start') || '22:00';
      const end = localStorage.getItem('settings.notifications.quietHours.end') || '07:00';
      const now = new Date();
      const hm = now.getHours() * 60 + now.getMinutes();
      const [sh, sm] = start.split(':').map((x) => parseInt(x, 10));
      const [eh, em] = end.split(':').map((x) => parseInt(x, 10));
      const s = sh * 60 + sm;
      const e = eh * 60 + em;
      if (s <= e) return hm >= s && hm <= e;
      return hm >= s || hm <= e;
    } catch (_) { return false; }
  };
  const playBeep = () => {
    try {
      const Ctor = window.AudioContext || window.webkitAudioContext;
      const ctx = new Ctor();
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = 'sine';
      o.frequency.value = 880;
      o.connect(g);
      g.connect(ctx.destination);
      g.gain.setValueAtTime(0.001, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + 0.01);
      o.start();
      o.stop(ctx.currentTime + 0.15);
    } catch (_) {}
  };

  const loadNotifiedNumbers = useCallback(() => {
    const storedNumbers = localStorage.getItem("notifiedNumbers");
    if (storedNumbers) {
      const parsedNumbers = JSON.parse(storedNumbers);
      setNotifiedNumbers(parsedNumbers);
      const increased = parsedNumbers.length > lastLenRef.current;
      if (increased && soundEnabledSetting && !isQuiet()) playBeep();
      lastLenRef.current = parsedNumbers.length;
      setHasUnreadNotifications(parsedNumbers.length > 0 && showBadgeSetting && !isQuiet());
    } else {
      setNotifiedNumbers([]);
      lastLenRef.current = 0;
      setHasUnreadNotifications(false);
    }
  }, []);

  useEffect(() => {
    loadNotifiedNumbers();
    const interval = setInterval(() => {
      loadNotifiedNumbers();
    }, 1000);

    return () => clearInterval(interval);
  }, [loadNotifiedNumbers]);
  const handleRemoveNotification = (numberToRemove) => {
    // Numaranın localStorage'dan kaldırılması
    const updatedNumbers = notifiedNumbers.filter(
      (number) => number !== numberToRemove
    );
    localStorage.setItem("notifiedNumbers", JSON.stringify(updatedNumbers));

    // Durumu güncelle
    setNotifiedNumbers(updatedNumbers);
    navigate("/is-emri/" + numberToRemove + "/");
  };

  // shake animasyonu CSS'te tanımlandı
  return (
    <Flex gap={3} alignItems='center'>
      {/* Notifications */}
      <Menu>
        <Tooltip label="Bildirimler" placement="bottom">
          <MenuButton 
            as={IconButton}
            icon={<Icon as={FiBell} boxSize={5} />}
            variant="ghost"
            size="md"
            borderRadius="xl"
            bg={bgColor}
            border="2px"
            borderColor={borderColor}
            color={hasUnreadNotifications ? "red.500" : iconColor}
            className={hasUnreadNotifications ? "animate-pulse" : ""}
            _hover={{
              bg: hoverBg,
              borderColor: hoverBorderColor,
              transform: "translateY(-1px)",
            }}
            _active={{
              transform: "translateY(0)",
            }}
            onClick={loadNotifiedNumbers}
            position="relative"
          >
            {hasUnreadNotifications && showBadgeSetting && !isQuiet() && (
              <Badge
                position="absolute"
                top="-1"
                right="-1"
                bg="#ef4444"
                color="white"
                borderRadius="full"
                boxSize="8px"
                p={0}
              />
            )}
          </MenuButton>
        </Tooltip>
        <MenuList
          bg={bgColor}
          border="2px"
          borderColor={borderColor}
          borderRadius="xl"
          shadow="xl"
          minW="250px"
        >
          {notifiedNumbers.length ? (
            notifiedNumbers.map((notification, index) => (
              <MenuItem 
                key={'notification_' + index} 
                onClick={() => handleRemoveNotification(notification)}
                _hover={{ bg: hoverBg }}
                borderRadius="lg"
                mx={2}
                my={1}
              >
                <HStack spacing={3}>
                  <Icon as={FiBell} color="#0ea5e9" />
                  <VStack align="start" spacing={0}>
                    <Text fontSize="sm" fontWeight="semibold" color={textColor}>
                      Yeni İş Emri
                    </Text>
                    <Text fontSize="xs" color={notificationTextColor}>
                      #{notification}
                    </Text>
                  </VStack>
                </HStack>
              </MenuItem>
            ))
          ) : (
            <MenuItem isDisabled>
              <Text fontSize="sm" color={notificationTextColor}>
                Bildirim bulunmuyor
              </Text>
            </MenuItem>
          )}
        </MenuList>
      </Menu>
      
      {/* User Info */}
      <Menu>
       
        <MenuList
          bg={bgColor}
          border="2px"
          borderColor={borderColor}
          borderRadius="xl"
          shadow="xl"
          minW="280px"
        >
         
        </MenuList>
      </Menu>

      <Menu>
        <Tooltip label="Profil Menüsü" placement="bottom">
          <MenuButton
            as={Box}
            cursor="pointer"
            borderRadius="xl"
            border="2px"
            borderColor={borderColor}
            p={1}
            bg={bgColor}
            _hover={{
              borderColor: hoverBorderColor,
              transform: "translateY(-1px)",
              shadow: "lg",
            }}
            _active={{
              transform: "translateY(0)",
            }}
            transition="all 0.2s"
          >
            <Avatar
              name={auth.data.user.username}
              src={auth.data.user.employee ? auth.data.user.employee.avatar : ""}
              boxSize='36px'
              border="2px"
              borderColor="white"
              shadow="md"
            />
          </MenuButton>
        </Tooltip>
        <MenuList
          bg={bgColor}
          border="2px"
          borderColor={borderColor}
          borderRadius="xl"
          shadow="xl"
          minW="200px"
        >
          <MenuItem isDisabled borderRadius="lg" mx={2} my={1}>
            <HStack spacing={3}>
              <Avatar
                name={auth.data.user.username}
                src={auth.data.user.employee ? auth.data.user.employee.avatar : ""}
                boxSize='32px'
              />
              <VStack align="start" spacing={0}>
                <Text fontSize="sm" fontWeight="bold" color={textColor}>
                  {auth.data.user.username}
                </Text>
                <Text fontSize="xs" color={notificationTextColor}>
                  Kullanıcı
                </Text>
              </VStack>
            </HStack>
          </MenuItem>
          <MenuItem 
            w="100%"
            onClick={handleAccount}
            _hover={{ bg: hoverBg }}
            borderRadius="xl"
            mx={1}
            my={3}
          >
            
            <HStack spacing={3}>
              
              <Icon as={FiSettings} color={iconColor} />
              <Text fontSize="sm" color={textColor}>
              Ayarlar
              </Text>
            </HStack>
          </MenuItem>
           <MenuGroup title="Bayi" color={menuGroupColor} fontSize="xs" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
            <MenuItem _hover={{ bg: hoverBg }} borderRadius="lg" mx={2} my={1}>
              {auth.data.user.employee?.reseller ? (
                <VStack align="start" spacing={1}>
                  <Link key="user-reseller" to={ "/bayi/" + urlToId(auth.data.user.employee.reseller.url) }>
                    <Text fontSize="sm" fontWeight="semibold" color={textColor}>
                      {auth.data.user.employee.reseller.name}
                    </Text>
                  </Link>
                  {auth.data.user.employee.is_manager && (
                    <Badge bg="#ef4444" color="white" size="sm" borderRadius="md">
                      Yönetici
                    </Badge>
                  )}
                </VStack>
              ) : (
                <Text fontSize="sm" color={notificationTextColor}>
                  Bayi bilgisi yok
                </Text>
              )}
            </MenuItem>
          </MenuGroup>
          <MenuGroup title="Takımlar" color={menuGroupColor} fontSize="xs" fontWeight="bold" textTransform="uppercase" letterSpacing="wide">
            {auth.data.user.employee?.team_memberships ? (
              auth.data.user.employee.team_memberships.map((team) => (
                <MenuItem key={team.team.url} _hover={{ bg: hoverBg }} borderRadius="lg" mx={2} my={1}>
                  <VStack align="start" spacing={1}>
                    <Text fontSize="sm" fontWeight="semibold" color={textColor}>
                      {team.team.name}
                    </Text>
                    {team.is_lead && (
                      <Badge bg="#f97316" color="white" size="sm" borderRadius="md">
                        Takım Lideri
                      </Badge>
                    )}
                  </VStack>
                </MenuItem>
              ))
            ) : (
              <MenuItem isDisabled>
                <Text fontSize="sm" color={notificationTextColor}>
                  Takım üyeliği yok
                </Text>
              </MenuItem>
            )}
          </MenuGroup>
          
          <MenuItem 
            onClick={handleLogOut}
            _hover={{ bg: "#fef2f2", color: "#dc2626" }}
            borderRadius="lg"
            mx={2}
            my={1}
          >
            <HStack spacing={3}>
              <Icon as={FiLogOut} color="#ef4444" />
              <Text fontSize="sm" color="#ef4444">
                Çıkış Yap
              </Text>
            </HStack>
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
}

